import { render, staticRenderFns } from "./TableforClientsMobile.vue?vue&type=template&id=85e518b8&scoped=true"
import script from "./TableforClientsMobile.vue?vue&type=script&lang=js"
export * from "./TableforClientsMobile.vue?vue&type=script&lang=js"
import style0 from "./TableforClientsMobile.vue?vue&type=style&index=0&id=85e518b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85e518b8",
  null
  
)

export default component.exports